import type { Database } from '@nozbe/watermelondb';
import { createContext, useContext } from 'react';
import type { SyncStatus } from '../utils/consts';

export interface OfflineModeContextType {
  database: Database;
  isOfflineModeLoading: boolean;
  isReady: boolean;
  error: Error | null;
  initialize: () => Promise<void>;
  syncDatabase: () => Promise<void>;
  clearDatabase: () => Promise<void>;
  syncStatus: SyncStatus;
  lastSyncTimestamp: string | null;
}

export const OfflineModeContext = createContext<OfflineModeContextType | null>(null);

export const useOfflineModeContext = () => {
  const context = useContext(OfflineModeContext);
  if (!context) {
    throw new Error('useOfflineModeContext must be used within an OfflineModeProvider');
  }
  return context;
};

export const useOfflineModeDatabase = () => {
  const context = useContext(OfflineModeContext);
  return {
    database: context?.database,
    isReady: context?.isReady,
    syncDatabase: context?.syncDatabase,
    clearDatabase: context?.clearDatabase,
    syncStatus: context?.syncStatus,
    lastSyncTimestamp: context?.lastSyncTimestamp,
  };
};
